import React, { useContext, useEffect, useState } from "react";
import { AppContext, AppContextInterface } from "../../state/ContextProvider";

import { Price } from "../../components/price/Price";
import { BrowseStock } from "./BrowseStock";
import NoValuationProvided from "./NoValuationProvided";
import { TrustPilotWidget } from "../../components/ratings-integration/trustpilotWidget";
import { getClosestDealerships, getLatitudeAndLongitude } from "../../utils/geoLocation-utils";
import { DateTime } from "luxon";
import ValuationInfoBox from "../../components/ValuationInfoBox/ValuationInfoBox";
import ValuationErrorBox from "../../components/ValuationErrorBox/ValuationErrorbox";

export type LocationType = {
  longitude: number; 
  latitude: number;  
}

const AppointmentContent: React.FC = () => {
  const {
    actions: { 
      addBookingDate, 
      addBookingTime, 
      addClosestDealerships,
      addDealershipGuid,
      addAppointmentDetails
    },
    state: { 
      valuation: { customerValuation } = {},
      closestDealerships,
      appointmentDetails,
      groupId,
      vehicleDetails,
      bookingDate,
      bookingTime,
      appointmentDetails: { dealership, postCode },
      bookingStatus
   },
    api: { getBooking },
  } = useContext(AppContext) as AppContextInterface;

  const [dealershipGuidError, setDealershipGuidError] = useState(false);
  const [latAndLong, setLatAndLong] = useState<any>(null);
  const [showError, setShowError] = useState<boolean>(false);
  
  useEffect(() => {
    if (customerValuation) {
      async function getLatAndLong() {
        // Comment out the await call and uncomment the hardcoded object when doing local dev work
        const [getGeoLocation]: any = await Promise.all([
          getLatitudeAndLongitude({postCode})
        ])
        // const getGeoLocation = {
        //   longitude: -2.242631,
        //   latitude: 53.480759
        // }
        setLatAndLong(getGeoLocation);
      }
      getLatAndLong();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerValuation])

  useEffect(() => {
    if (latAndLong) {
      async function setClosestDealerships() {
        const dealershipArray = await getClosestDealerships(
          groupId.toString(), 
          latAndLong, 
          vehicleDetails.requestResultsType.asset.primaryAssetData.dvla.make.description
        );

        if (dealershipArray) {
          addClosestDealerships({
            ...closestDealerships,
            data: dealershipArray,
          })
        }
      }
      setClosestDealerships();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latAndLong]);

  useEffect(() => {
    if (closestDealerships.length > 0) {
      const currentDateAndTime =  DateTime.now()
      const currenDate = currentDateAndTime.setLocale("en-GB").toLocaleString()
      let hour = currentDateAndTime.hour.toString()
      let minute = currentDateAndTime.minute.toString()

      let currentTime = ""
      
      if (hour.length < 2) {
        hour = `0${hour}`
      } 

      if (minute.length < 2) {
        minute = `0${minute}`
      }

      currentTime = `${hour}:${minute}`

      addBookingDate(currenDate)

      addBookingTime(currentTime)

      addAppointmentDetails({
				...appointmentDetails,
				dealership: closestDealerships[0].Value,
			})

      addDealershipGuid(closestDealerships[0].GlobalDealershipId)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closestDealerships]);

  useEffect(() => {
    if (bookingDate && bookingTime && dealership && customerValuation) {
      getBooking();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingDate, bookingTime, dealership])

  useEffect(() => {
    if (bookingStatus.status === 200 || bookingStatus.status === 201) {
      setShowError(false)
    } else if (bookingStatus.status !== 0) {
      setShowError(true)
    }
  }, [bookingStatus])


  const errorForNoDealershipGuid = (error: boolean) => {
    error ? setDealershipGuidError(true) : setDealershipGuidError(false);
  };

  return (
    <>
      {customerValuation ? (
        <>
          <Price valuation={customerValuation} />
          <TrustPilotWidget />
          {showError && <ValuationErrorBox />}
          <ValuationInfoBox showError={showError}/>
          <BrowseStock />
        </>
      ) : (
        <NoValuationProvided
          dealershipGuidError={dealershipGuidError}
          errorForNoDealershipGuid={errorForNoDealershipGuid}
        />
      )}
    </>
  );
};

export default AppointmentContent;
